/**
 * @generated SignedSource<<12e5b2072ceeb9ba123e0b37966bbbab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferSubmit_transaction$data = {
  readonly isPrivateOffer: boolean | null;
  readonly " $fragmentType": "CheckoutWireTransferSubmit_transaction";
};
export type CheckoutWireTransferSubmit_transaction$key = {
  readonly " $data"?: CheckoutWireTransferSubmit_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferSubmit_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferSubmit_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateOffer",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "ced0eee295cb2ea8e6cf5f13ffbc1f10";

export default node;
